/*
 * Entry point of the application.
 * Only platform bootstrapping code should be here.
 * For app-specific initialization, use `app/app.component.ts`.
 */
import { bootstrapApplication } from '@angular/platform-browser';

import { environment } from '@env/environment';
import * as Sentry from '@sentry/angular';

import { appVersion } from '@personal-area/common';
import { GTMService } from '@personal-area/global/gtm';
import { errorFilter } from '@personal-area/global/sentry';

import { appBrowserConfig } from './app/app.browser.module';
import { AppComponent } from './app/app.component';
import { Hotjar } from './app/core/utility/hotjar';

if (environment.sentry.enabled) {
  Sentry.init({
    release: appVersion(),
    dsn: environment.sentry.DSN,
    allowUrls: [
      window.location.origin, // skip errors from external libraries and browser extensions
    ],
    denyUrls: ['fbstest1.com', 'fbstest2.com'],
    ignoreErrors: ['Non-Error exception captured', '404'],
    beforeSend: errorFilter,
    integrations: [
      Sentry.breadcrumbsIntegration({ xhr: false, fetch: false }),
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    sampleRate: 0.5,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 0.5,
  });
}

if (environment.hotjar.enable) {
  Hotjar.createSession(
    environment.hotjar.trackingId,
    environment.hotjar.version,
  );
}

if (environment.gtm.enable) {
  GTMService.createGTMSession(environment.gtm.trackingId);
}

bootstrapApplication(AppComponent, appBrowserConfig).then(() => {
  if ('serviceWorker' in navigator && environment.production) {
    navigator.serviceWorker.register('/cabinet/ngsw-worker-polyfill.js');
  }
});
